import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getfinishJobList = createAsyncThunk(
  "finishJobList/getfinishJobList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contractor/complete_booking`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const finishJobSlice = createSlice({
  name: "finishJobList",
  initialState: {
    loading: false,
    finishJobData: null,
    error: null,
  },
  reducers: {
    ResetFinishJob: (state) => {
      state.finishJobData = null; // Clear old data
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getfinishJobList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getfinishJobList.fulfilled, (state, action) => {
        state.loading = false;
        state.finishJobData = action.payload;
      })
      .addCase(getfinishJobList.rejected, (state, action) => {
        state.loading = false;
        state.finishJobData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetFinishJob } = finishJobSlice.actions;
export default finishJobSlice.reducer;
